module.exports = __webpack_public_path__ + "media/images/icon__plus-72d888d4dffb8691cdf0abf725f319d6.png";